// Key for "these two instances of one fragment coincide": same position,
// same diagonal. Used by the pooled path (instanceMaterializer) and the
// batched path (streamingController._collectBatchItems) to drop exact
// duplicates, which would z-fight and hide the selection highlight.
//
// The translation lives at DIFFERENT indices depending on where the row
// came from: JSON sidecar rows are C# row-major (translation at 3, 7, 11),
// binary sidecar rows (sidecarFormat 2) and override-moved rows are
// column-major (`cm: true`, translation at 12, 13, 14). The diagonal
// (0, 5, 10) is the same in both.
//
// Both call sites used to read 3/7/11 unconditionally. On a column-major
// row those are the bottom row, 0/0/0, so every same-orientation instance
// of a fragment in a tile produced the same key and all but the first were
// skipped as "duplicates" - wherever they actually stood. On SpaceX BA03
// (export 20260926_051328_614) that was 1,190,012 of 1,448,737 rows: the
// hanger nuts, washers, rods and strut that "went missing" since the binary
// sidecar became the preferred format (2026-09-08). Truly coincident rows
// in that export: 2,935.
export function coincidentKey(entry) {
  const m = entry.deltaMatrix;
  const tx = entry.cm ? m[12] : m[3];
  const ty = entry.cm ? m[13] : m[7];
  const tz = entry.cm ? m[14] : m[11];
  return tx.toFixed(4) + ',' + ty.toFixed(4) + ',' + tz.toFixed(4)
       + '|' + m[0].toFixed(4) + ',' + m[5].toFixed(4) + ',' + m[10].toFixed(4);
}
